/* eslint-disable */
const API_HOST = process.env.API_HOST
const API_PATH = 'api'
const CLIENT_ID = process.env.NODE_ENV === 'development' ? 'WebDev' : 'Web'
const Barcode_Url = 'https://open.freshif.com/barcode/product/getinfo'
const Image_Host = 'https://img.mixct.cn/'
const Test_API_HOST = 'http://localhost:5588/'

var config = {
  ApiHost: API_HOST,
  ApiPath: API_PATH,
  ClientId: CLIENT_ID,
  BarcodeUrl: Barcode_Url,
  ImageHost: Image_Host
}

var test_config = {
  ApiHost: Test_API_HOST,
  ApiPath: API_PATH,
  ClientId: CLIENT_ID,
  BarcodeUrl: Barcode_Url,
  ImageHost: Image_Host
}

export default config






// WEBPACK FOOTER //
// ./src/config.js